export const TOGGLE_AREA_EXPANDED: string = '[areas] Toggle Area Expanded';

export const toggleAreaExpanded = (id: number) => ({
  type: TOGGLE_AREA_EXPANDED,
  payload: id,
});
